import React from "react";
import { Checkbox, Tooltip } from "@material-ui/core";

type Props = {
  checked: boolean;
  onChange: () => void;
  getIsDisabled: () => [boolean, string];
};

const CheckboxWithDisableTooltip = ({
  checked,
  onChange,
  getIsDisabled,
}: Props): JSX.Element => {
  const [isDisabled, tooltip] = getIsDisabled();
  let checkbox = (
    <Checkbox checked={checked} onChange={onChange} disabled={isDisabled} />
  );
  if (isDisabled && tooltip) {
    checkbox = (
      <Tooltip title={tooltip}>
        <span>{checkbox}</span>
      </Tooltip>
    );
  }
  return checkbox;
};

export default CheckboxWithDisableTooltip;
